var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "language-switcher" }, [
    _c("h3", [_vm._v(_vm._s(_vm.$t("Base.language")))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "lang-container" },
      _vm._l(_vm.languages, function(lang, i) {
        return _c(
          "div",
          {
            key: i,
            staticClass: "lang",
            on: {
              click: function($event) {
                return _vm.selectLocale(lang)
              }
            }
          },
          [
            _c(
              "span",
              {
                class: {
                  "active-language": lang.toLowerCase() === _vm.$i18n.locale
                }
              },
              [_vm._v(_vm._s(_vm.fullName[lang]))]
            )
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55622826", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55622826","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/parts/LanguageSwitcher.vue
// module id = null
// module chunks = 